import isNumber from 'lodash/isNumber';

export const degreesToRadians = degrees => degrees * (Math.PI / 180);

// Check if an angle is a number and in between 0-360
export const isAngle = angle => isNumber(angle) && angle >= 0 && angle <= 360;
